// Staff role helpers. 'owner' is the tenant-owner role (a shop's own account
// on Bouqmark) — a superset of 'admin'. Every admin gate in the frontend goes
// through these so the two roles can never drift apart; the backend mirrors
// them in backend/lib/roles.js.
export const ADMIN_ROLES = ['admin', 'owner'];

export const isAdminRole = (role) => ADMIN_ROLES.includes(role);
export const hasAdminRights = (user) => !!user && isAdminRole(user.role);

// Owner-only operations (billing, Stripe connect, domains). The backend
// enforces the same rule with requireOwner; this only decides what to show.
export const isOwnerRole = (role) => role === 'owner';
export const isOwner = (user) => !!user && isOwnerRole(user.role);

/**
 * Whether the Payment tab should show: admins and owners always; a login with
 * card access; or, on the shared staff login, the selected sub-member with card
 * access (live value from the profile's staffMembers, else the saved selection).
 * The backend gates every request regardless.
 */
export const canSeePaymentTab = (user, selectedStaff) => {
  if (hasAdminRights(user) || user?.canAccessCards) return true;
  if (!selectedStaff) return false;
  const live = (user?.staffMembers || []).find(m => m.id === selectedStaff.id);
  return !!(live ? live.canAccessCards : selectedStaff.canAccessCards);
};
